export default __webpack_public_path__ + "static/media/continuous-process-tab.80232c42.png";